﻿<template>
    <div class="container">
        <div class="mb-3">{{ $t('productAddedToComparisonToast') }}</div>

        <div class="row d-flex justify-content-between">

            <div class="col-12">
                <a href="/product/compare" class="btn btn-primary btn-md rounded-pill btn-trimm-wide">
                    {{ $t('goToComparison') }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'compare-toast'
    };
</script>